import { render, staticRenderFns } from "./UploadFilesRFQ.vue?vue&type=template&id=7bef2d86&scoped=true"
import script from "./UploadFilesRFQ.vue?vue&type=script&lang=js"
export * from "./UploadFilesRFQ.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesRFQ.vue?vue&type=style&index=0&id=7bef2d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef2d86",
  null
  
)

export default component.exports